// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"77c87470","40":"00feb72b","152":"74f28c10","171":"690f36a1","446":"c9aa1395","507":"9833bebb","599":"13f8b922","743":"3d999531","753":"738a2b3b","759":"542727e8","780":"d2d2d43a","845":"eb5888d9","940":"1f742bf3","968":"82940e91"}[chunkId] + ".chunk.js";
};